import { PureComponent } from 'react';
import Script from 'react-load-script';

import Link from 'Component/Link';

import './SocialShare.style';

/** @namespace Pwa/Component/SocialShare/Component */
export class SocialShare extends PureComponent {
    handleScript() {
        // eslint-disable-next-line no-undef
        a2a.init('page');
    }

    render() {
        const {
            product: { name },
            isEnabled,
            isFacebookEnabled,
            isTwitterEnabled,
            isMessengerEnabled,
            isPinterestEnabled,
            isLlinkedinEnabled,
            isLTumblrEnabled,
        } = this.props;

        const productUrl = window.location.href;
        const productName = name;
        const renderSocialShare =
            +isEnabled &&
            (+isFacebookEnabled ||
                +isTwitterEnabled ||
                +isMessengerEnabled ||
                +isPinterestEnabled ||
                +isLlinkedinEnabled ||
                +isLTumblrEnabled);

        return renderSocialShare ? (
            <>
                <Script url="https://static.addtoany.com/menu/page.js" onLoad={() => this.handleScript()} />
                <p>{__('Share product with friends')}</p>
                <div
                    className="a2a_kit a2a_kit_size_32 a2a_default_style"
                    data-a2a-url={productUrl}
                    data-a2a-title={productName}
                >
                    {+isFacebookEnabled ? <Link to="/" title="" mix={{ block: 'a2a_button_facebook' }} /> : null}
                    {+isTwitterEnabled ? <Link to="/" title="" mix={{ block: 'a2a_button_twitter' }} /> : null}
                    {+isMessengerEnabled ? (
                        <Link to="/" title="" mix={{ block: 'a2a_button_facebook_messenger' }} />
                    ) : null}
                    {+isPinterestEnabled ? <Link to="/" title="" mix={{ block: 'a2a_button_pinterest' }} /> : null}
                    {+isLlinkedinEnabled ? <Link to="/" title="" mix={{ block: 'a2a_button_linkedin' }} /> : null}
                    {+isLTumblrEnabled ? <Link to="/" title="" mix={{ block: 'a2a_button_tumblr' }} /> : null}
                </div>
            </>
        ) : null;
    }
}

export default SocialShare;
